import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import LockIcon from '@material-ui/icons/Lock'
import CreditCardIcon from '@material-ui/icons/CreditCard'
import { FormattedMessage } from 'react-intl'
import clsx from 'clsx'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import { Link } from 'react-router-dom'
import { Routes } from 'app/services/routeService/routeService'

const useStyles = makeStyles((theme) => ({
  lockIcon: {
    fontSize: '9.6rem',
  },
  description: {
    color: theme.palette.darkGrey.main,
  },
}))

const PaidPlanAccessFullScreen = () => {
  const classes = useStyles()
  return (
    <div className="w-full h-full flex flex-auto flex-col justify-center items-center">
      <LockIcon className={classes.lockIcon}>lock</LockIcon>
      <div className="max-w-xs flex flex-col items-center">
        <p
          className={clsx(
            classes.description,
            'my-36 text-center leading-normal',
          )}
        >
          <FormattedMessage id="paidPlanRestriction.description.text" />
        </p>
        <Link
          to={Routes.billingchangePlan()}
          className="w-full h-48 no-underline"
        >
          <PrimaryButton className="w-full h-full">
            <CreditCardIcon />
            <FormattedMessage id="paidPlanRestriction.button.text" />
          </PrimaryButton>
        </Link>
      </div>
    </div>
  )
}

export default PaidPlanAccessFullScreen
